import classNames from "classnames";
import { get } from "lodash";
import { MdOpenInNew } from "react-icons/md";
import Button from "../../Components/Button";
import Cost from "../../Components/Cost";

const ProductCard = ({
  icon,
  name,
  description,
  price,
  action,
  quoteAction,
  info,
  links,
  recommendation,
  showGuarantee,
}) => {
  return (
    <div className="product--item">
      <div
        className={classNames({
          "recommended--product": recommendation?.value,
        })}
      >
        <div className="product--item--wrapper">
          {recommendation?.value && (
            <span className="product--item--tag">Notre recommandation</span>
          )}
          <div className="product--item--header">
            <span className="product--item--header--name">{name}</span>
            <Cost
              cost={get(price, "cost", 0)}
              currency={get(price, "currency", "EUR")}
              showYearly
            />
          </div>
          <div className="product--item--action">
            <Button
              type="primary"
              onClick={action?.onClick}
              loading={action?.loading}
              disabled={action?.disabled}
            >
              {action?.label}
            </Button>
            <br />
            <Button
              type="primary-outlined"
              onClick={quoteAction?.onClick}
              loading={action?.loading}
              disabled={quoteAction?.disabled}
            >
              {quoteAction?.label}
            </Button>
          </div>
          <div className="product--item--info">
            <span className="product--item--info--title">{info?.title}</span>
            <div className="product--item--info--list">
              {get(info, "items", []).map((item, i) => (
                <div key={i} className="item">
                  <span className="content">
                    {item.mainInfo || item.coverage}
                  </span>
                  <div className="item--right">
                    <span className="value">{item.value || item.limit}</span>
                    {/* <MdInfoOutline
                      onClick={() => showGuarantee(item)}
                      size={16}
                      className="help-icon"
                    /> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="product--item--links">
            <div className="product--item--link" onClick={links?.example}>
              <span>Exemples de remboursement</span>
              <MdOpenInNew size={14} />
            </div>
            <div className="product--item--link" onClick={links?.guarantees}>
              <span>Tableau des garanties</span>
              <MdOpenInNew size={14} />
            </div>
            <div className="product--item--link" onClick={links?.ipid}>
              <span>Fiche IPID</span>
              <MdOpenInNew size={14} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
